import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";

// Redux
import { savePreQuoteType } from "./preQuoteTypeActions";
import { GetPreQuoteType } from "./preQuoteTypeTypes";

// Api's
import { quoteApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";
import { KeyValue } from "@/main/models/common";

export function* getPreQuoteTypeSaga(_action: GetPreQuoteType) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(quoteApi.domainPreQuoteType);

		if (response.data.result) {
			yield put(savePreQuoteType(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(savePreQuoteType(null, true, resultError.messagesDataError));
		}
	}
}
